import { Button, Modal, Tag } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import {
  createWorkflowCardFromCatalog,
  WorkflowByCatalogFilter,
  workflowsByCatalogLoader,
} from "src/business/workflow/apiWorkflow";
import { getWorkflowDisplayName } from "src/business/workflow/getWorkflowDisplayName";
import { ZWorkflow } from "src/business/workflow/ZWorkflow";
import { onError } from "src/common/onError";
import { MdmTable } from "src/components/MdmTable";
import { RtStore } from "src/components/ReactiveTable/RtStore";

import { columns } from "./columns";

type PropsSelectWorkflowModal = {
  open: boolean;
  catalogId: string;
  catalogCardId: string;
  onClose(): void;
  onSuccess(wfCardId: string): void;
};

export const SelectWorkflowModal: React.FC<PropsSelectWorkflowModal> = observer(
  ({ open, catalogId, catalogCardId, onClose, onSuccess }) => {
    const table = React.useMemo(
      () =>
        new RtStore<ZWorkflow, WorkflowByCatalogFilter>({
          rowKey: "id",
          loader: workflowsByCatalogLoader(catalogId),
          selectionType: "radio",
        }),
      [catalogId],
    );
    const [submitting, setSubmitting] = React.useState(false);

    const selectedWorkflow = table.selectedRows[0];

    const handleSelect = async () => {
      if (!selectedWorkflow) return;
      try {
        setSubmitting(true);
        const wfCard = await createWorkflowCardFromCatalog(
          catalogCardId,
          selectedWorkflow.id,
        );
        onSuccess(wfCard.id);
      } finally {
        setSubmitting(false);
      }
    };

    return (
      <Modal
        title="Выбор рабочего потока"
        open={open}
        onCancel={onClose}
        width="80vw"
        footer={[
          <Button key="cancel" onClick={onClose}>
            Отменить
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={!selectedWorkflow}
            loading={submitting}
            onClick={() => handleSelect().catch(onError)}
          >
            Выбрать
          </Button>,
        ]}
      >
        {selectedWorkflow && (
          <div style={{ marginBottom: 12 }}>
            Выбрано:{" "}
            <Tag>
              {getWorkflowDisplayName(selectedWorkflow) || selectedWorkflow.id}
            </Tag>
          </div>
        )}
        <div style={{ height: "60vh" }}>
          <MdmTable
            resizableColumns
            store={table}
            columns={columns}
            verticalMode="fit"
          />
        </div>
      </Modal>
    );
  },
);
